import { Form, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { TipoSolicitacaoProps } from './props';
import Swal from 'sweetalert2';
import TextFilter from '../TextFilter';
import { TipoSolicitacao, tipoSolicitacao } from './service/tipoSolicitacao';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';


const SelectTipoSolicitacao: React.FC<TipoSolicitacaoProps> = ({
  setTipoSolicitacao,
  required,
  name,
}) => {
  const { Option } = Select;
  const [response, setResponse] = useState<TipoSolicitacao[]>([]);
  const role = useSelector((state: ApplicationState) => state.auth.user?.perfil);


  useEffect(() => {
    try {
      tipoSolicitacao.getTiposSolicitacao().then((res) => {

        const responseSorted = res.data.tiposSolicitacao.sort((a: { descricao: string }, b: { descricao: string }) => {
          return a.descricao.toUpperCase() < b.descricao.toUpperCase()
            ? -1
            : a.descricao.toUpperCase() > b.descricao.toUpperCase()
              ? 1
              : 0;
        });

        const validatedResponse = responseSorted.filter((item) =>
          item.show.includes(role?.toString() as string)
        );

        setResponse(validatedResponse);

      });
    } catch (error) {
      Swal.fire({
        title:
          'Não foi possivel carregar a lista dos tipos de solicitações, por favor atualize a página!',
        html: '',
        icon: 'warning',
        showConfirmButton: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChange = (values: any) => {
    setTipoSolicitacao(JSON.parse(values));
    localStorage.setItem(`tipoSolicitacao${window.location.pathname}`, JSON.stringify(values));
  };

  return (
    <>
      <Form.Item
        label={<TextFilter>Tipo de solicitação</TextFilter>}
        name={name ? name : 'tipoSolicitacao'}
        rules={[{ required: required, message: 'Por favor preencha este campo' }]}
      >
        <Select
          data-cy="tipoDeSolicitacao"
          onChange={onChange}
          style={{ width: '100%' }}
          showSearch
          optionFilterProp={'children'}
          filterOption={(input, option) =>
            option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {response.map((item) => (

            <Option value={JSON.stringify(item)} key={item.codigo}>
              {item.descricao}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </>
  );
};

export default SelectTipoSolicitacao;
